import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
export const BoldMatchingText = ({
  match,
  children,
  isSmall = false
}) => {
  if (match === '') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  // we need to escape special characters to avoid getting them interpreted in the RegExp group
  const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
  const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, parts.map((part, i) => {
    if (part.toLowerCase() === match.toLowerCase()) {
      return /*#__PURE__*/React.createElement(Text, {
        testId: "cmdb-edit-dropdown-option.bold-text",
        as: "strong",
        size: isSmall ? 'small' : undefined,
        key: i
      }, part);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, part);
  }));
};
export const getVisibleAttributes = (attributes, attributesToDisplay) => {
  const notUndefined = attr => {
    return Boolean(attr);
  };
  return attributesToDisplay.map(attrName => attrName === 'Label' ? attributes.find(attr => attr.objectTypeAttribute.label) : attributes.find(attr => attr.objectTypeAttribute.name === attrName)).filter(notUndefined).filter(attribute => attribute.objectAttributeValues.length > 0 && attribute.objectAttributeValues.every(value => value && value.displayValue));
};
export const createAttributeString = attributes => {
  return attributes.map(attribute => attribute.objectAttributeValues.map(value => value.displayValue).join(', ')).join(' | ');
};
export const createLabelString = (attributes, defaultLabel) => {
  var _attributes$;
  return ((_attributes$ = attributes[0]) === null || _attributes$ === void 0 ? void 0 : _attributes$.objectAttributeValues.map(v => v.displayValue).join(', ')) || defaultLabel;
};